import React, {useEffect, useState} from "react";
import {formatNumber} from "../../../../components/commonmethod/CommonMethod";
import {getDepreciationByAsset} from "../../../../api/asset/AssetDepreciationService";
import {DetailEntityShell, DetailPanel, DetailKvTable} from "../../../../components/detailLayout";
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {depreciationType} from "../../finance/depreciation/AssetDepreciationCreate";
import {skeleton} from "../../../../redux/slice/apiSlice";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import DepreciationCalcTable from "../../finance/depreciation/components/DepreciationCalcTable";

function AssetDepreciation({id, name}) {
    const [calc, setCalc] = useState([]);
    const [depreciation, setDepreciation] = useState();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const validateDepreciation = (target) => {
        let isValid = true;

        if (target && target.type === "정률법" && target.rate > 100) {
            alert("감가상각률은 100%를 넘을 수 없습니다. \n감가상각률 또는 계산방법을 변경해주세요");
            setDepreciation((prev) => ({
                ...prev,
                rate: null,
                required_validate: {...prev?.required_validate, rate: false},
            }));
            isValid = false;
        } else if (target && target.type === "정액법" && parseInt(target.rate) > parseInt(target.price)) {
            alert("잔존가치는 취득가액을 넘을 수 없습니다. \n잔존가치 또는 계산방법을 변경해주세요");
            setDepreciation((prev) => ({
                ...prev,
                rate: null,
                required_validate: {...prev?.required_validate, rate: false},
            }));
            isValid = false;
        }
        return isValid;
    };

    const calcAndReturnList = (target) => {
        const list = [];
        let price = target.price;
        let sum = 0;

        const isValid = validateDepreciation(target);
        if (isValid) {
            for (let i = 0; i < parseInt(target.year); i++) {
                const dateText = `${parseInt(target.depreciationDate.split("-")[0]) + i}-${target.depreciationDate.split("-")[1]}-${target.depreciationDate.split("-")[2]}`;

                if (target.type === "정률법") {
                    const ll = Math.floor(price * target.rate / 100);
                    price -= ll;
                    sum += ll;

                    list.push({
                        id: i,
                        year: dateText,
                        annual: `${i + 1}년차`,
                        amount: formatNumber(ll),
                        accumulated: formatNumber(sum),
                        remain: formatNumber(price),
                    });
                } else if (target.type === "정액법") {
                    const ll = Math.floor((target.price - target.rate) / parseInt(target.year));
                    sum += ll;

                    list.push({
                        id: i,
                        year: dateText,
                        annual: `${i + 1}년차`,
                        amount: formatNumber(ll),
                        accumulated: formatNumber(sum),
                        remain: formatNumber(target.price - sum),
                    });
                }
            }
        }
        return list;
    };

    useEffect(() => {
        getDepreciationByAsset(id).then((response) => {
            if (response.status === 200) {
                setDepreciation(response.data);
                setCalc(calcAndReturnList(response.data));
            } else if (response.status === 401) {
                alert("로그인이 필요합니다.");
                navigate("/");
            } else if (response.status === 403) {
                alert("권한이 없습니다.");
                navigate("/");
            }
        });
        dispatch(skeleton(false));
    }, [id, dispatch, navigate]);

    const summaryMeta = depreciation
        ? [depreciation.item && `항목 ${depreciation.item}`, depreciation.type && `방법 ${depreciation.type}`]
              .filter(Boolean)
              .join(" · ")
        : undefined;

    return (
        <DetailEntityShell
            title={depreciation?.asset?.assetName ?? name ?? "감가상각"}
            meta={summaryMeta}
            canUpdate={false}
            listUrl="/asset/list"
        >
            <DetailPanel title="기본정보">
                <DetailKvTable>
                    <tbody>
                    <tr>
                        <Th_title title={"자산명"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"asset"} value={depreciation?.asset.assetName ?? name} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"자산항목"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"item"} value={depreciation?.item} />
                        </Th_title>
                        <Th_title title={"계산방법"} colspan={1} className="fieldset-td" required={true}>
                            <ReadOnlyInputBasic target={"type"} value={depreciation?.type} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"내용연수"} colspan={1} className="fieldset-td" required={true}>
                            <ReadOnlyInputBasic target={"year"} value={depreciation?.year} />
                        </Th_title>
                        <Th_title title={depreciation ? depreciation?.type && depreciationType.find(item => item.name === depreciation?.type)?.text : "정률법"} colspan={1} className="fieldset-td" required={true} auth>
                            <ReadOnlyInputBasic target={"rate"} value={depreciation?.rate} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"취득 일자"} colspan={1} className="fieldset-td" required auth>
                            <ReadOnlyInputBasic target={"depreciationDate"} value={depreciation?.depreciationDate} />
                        </Th_title>
                        <Th_title title={"취득가액(단위 : 원)"} colspan={1} className="fieldset-td" required auth>
                            <ReadOnlyInputBasic target={"price"} value={formatNumber(depreciation?.price)} />
                        </Th_title>
                    </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>

            <DetailPanel title="계산">
                <DepreciationCalcTable rows={calc} />
            </DetailPanel>
        </DetailEntityShell>
    );
}

export {AssetDepreciation};
